import React from 'react'
import PropTypes from 'prop-types'

import Glyph from 'component/utils/Glyph'

import chevronDown from 'images/chevron-down.svg'

const EMPTY = '-'

const ViewTable = ({
  handleResize,
  lsDsProfiles,
  openViewModal,
  records,
  translate,
  onOrderChange,
  orderBy,
}) => {
  const lsDsProfilesLength = lsDsProfiles.length

  const renderHeader = () => (
    <tr>
      <th onClick={onOrderChange} className='cursor-pointer'>
        {translate('missionMenu.table.header.profileName')}&nbsp;&nbsp;
        <img
          className={`order-by-chevron ${orderBy && 'invert-chevron'}`}
          src={chevronDown}
        />
      </th>
      <th>{translate('missionMenu.table.header.ldap')}</th>
      <th>{translate('missionMenu.table.header.registerType')}</th>
      <th className='text-align-center'>
        {!lsDsProfilesLength &&
          translate('missionMenu.table.header.permissions')}
      </th>
    </tr>
  )

  const renderBody = () => {
    handleResize()

    const renderRecord = (record) => {
      const dsProfile =
        record.dsProfile + (record.dsLdap ? record.dsLdap : record.cdMission)

      return (
        <tr key={dsProfile}>
          <td>{record.dsProfile}</td>
          <td>{record.dsLdap || EMPTY}</td>
          <td>
            {translate(
              record.cdMission
                ? 'missionMenu.table.mission'
                : 'missionMenu.table.personalProfile'
            )}
          </td>
          <td
            onClick={() => (!lsDsProfilesLength ? openViewModal(record) : {})}
            className='mission-block-edit-icon'
          >
            {!lsDsProfilesLength && <Glyph type='eye' color='primary' />}
          </td>
        </tr>
      )
    }

    return records.map(renderRecord)
  }

  return (
    <table cellPadding={0} cellSpacing={0} className='new-table'>
      <thead>{renderHeader()}</thead>
      <tbody>{renderBody()}</tbody>
    </table>
  )
}

ViewTable.propTypes = {
  handleResize: PropTypes.func.isRequired,
  lsDsProfiles: PropTypes.array.isRequired,
  openViewModal: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  setLsDsProfiles: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  onOrderChange: PropTypes.func,
  orderBy: PropTypes.bool,
}

export default ViewTable
